// Shared helpers for rendering tier/feature data from the flat-tier license system
// (services/license.py TIERS). Used by StorePage (browse/purchase tiers) and
// BillingPage (manage current plan).

// Features included in every tier: hide these when listing what a paid tier adds
export const ALWAYS_INCLUDED = [
  "chat", "chat_code", "chat_analyze", "local_storage", "custom_branding",
  "web_search", "browse_url", "screenshot", "basic_skills", "lan_p2p_sync",
];

// De naam van elke feature in het Nederlands; de Engelse staat in `taal-en.js`.
// Los punt 21 oktober 2026: hier stonden Engelse namen, en een sleutel zonder naam
// werd Title Case uit de sleutel gemaakt, dus een NL-scherm toonde Engels. De
// aanroeper geeft de naam door `t()`; `billing.test.js` eist dat elke naam hier een
// Engelse vertaling heeft, want de dekkingswachter ziet alleen letterlijke `t("...")`.
export const FEATURE_NAMEN = {
  chat: "Chatten",
  chat_code: "Chatten over code",
  chat_analyze: "Chatten en analyseren",
  local_storage: "Lokale opslag",
  custom_branding: "Eigen huisstijl",
  web_search: "Zoeken op internet",
  browse_url: "Webpagina's openen",
  screenshot: "Schermafbeelding van een webpagina",
  basic_skills: "Basisskills",
  lan_p2p_sync: "Synchronisatie via het lokale netwerk",
  code_execution: "Code uitvoeren",
  personal_knowledge_base: "Persoonlijke kennisbank (RAG)",
  team_knowledge_base: "Teamkennisbank",
  compute_sharing_pool: "Rekenkracht delen",
  central_billing: "Centrale facturering voor alle plaatsen",
  full_marketplace: "Volledige Galaxy-marktplaats",
  skill_publishing: "Skills publiceren in Galaxy",
  click_element: "Klikken en werken op pagina's",
  type_text: "Typen in formulieren",
  form_fill: "Formulieren met meerdere velden invullen",
  council: "Raad (overeenstemming tussen modellen)",
  team_workspaces: "Teamwerkruimtes",
  priority_support: "Ondersteuning met voorrang",
};

/** De NL-naam van een feature, of de sleutel leesbaar gemaakt als hij onbekend is. */
export function formatFeature(key) {
  return FEATURE_NAMEN[key] || key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}
